import { useState } from 'react';

import { wait } from 'utils/helper/common';

const useIsLoading = (minTime: number = 300): [boolean, (a: boolean) => Promise<void>] => {
  let timestampOfPrevSwitchOn = 0;
  const [isLoading, setIsLoading] = useState(false);
  const isLoadingSetter = async (value: boolean): Promise<void> => {
    if (!value) {
      const now = (new Date()).getTime();
      const sinceLastUpdate = now - timestampOfPrevSwitchOn;
      const diff = minTime <= sinceLastUpdate ? 0 : minTime - sinceLastUpdate;

      await wait(diff);
    }

    setIsLoading(value);
    timestampOfPrevSwitchOn = value ? (new Date()).getTime() : 0;
  };

  return [isLoading, isLoadingSetter];
};

export default useIsLoading;
